export const enUS = {
  translation: {
    "title/Crossnote": "Crossnote",
    "search/notes": "Search Notes",
    "search/notebooks": "Search Notebooks",
    "search/attachments": "Search Attachments",

    // Account
    "account/Anonymous": "Anonymous",
    "account/anonymous": "anonymous",

    // General
    "general/go-back": "Go back",
    "general/sending": "Sending",
    "general/send": "Send",
    "general/cancel": "Cancel",
    "general/add": "Add",
    "general/adding": "Adding",
    "general/backed-up-at": "Backed up at",
    "general/created-at": "Created at",
    "general/modified-at": "Modified at",
    "general/interacted-at": "Interacted at",
    "general/date-created": "Date created",
    "general/date-modified": "Date modified",
    "general/date-interacted": "Date interacted",
    "general/title": "Title",
    "general/saved-at": "Saved at",
    "general/loading": "Loading ...",
    "general/loading-notifications": "Loading notifications ...",
    "general/failed-to-set": "Failed to set",
    "general/update": "Update",
    "general/updated": "Updated",
    "general/updating": "Updating",
    "general/close": "Close",
    "general/Note": "Note",
    "general/notes": "Notes",
    "general/Settings": "Settings",
    "general/Collaborators": "Collaborators",
    "general/collaborators": "collaborators",
    "general/Backups": "Backups",
    "general/backups": "backups",
    "general/Discussion": "Discussion",
    "general/discussion": "discussion",
    "general/Notifications": "Notifications",
    "general/Username": "Username",
    "general/Email": "Email",
    "general/Password": "Password",
    "general/confirm-password": "Confirm password",
    "general/Continue": "Continue",
    "general/enter-username": "Enter username",
    "general/vickymd": "VickyMD",
    "general/tags": "Tags",
    "general/add-a-tag": "Add a tag",
    "general/private": "Private",
    "general/public": "Public",
    "general/friends-only": "Friends only",
    "general/anonymous": "Anonymous",
    "general/onymous": "Onymous",
    "general/Tag": "Tag",
    "general/no-tags": "No tags",
    "general/Directory": "Directory",
    "general/Untitled": "Untitled",
    "general/untitled": "untitled",
    "general/Unknown": "Unknown",
    "general/unknown": "unknown",
    "general/Agree": "Agree",
    "general/Disagree": "Disagree",
    "general/Print": "Print",
    "general/Share": "Share",
    "Editor": "Editor",
    "EDITOR": "EDITOR",
    "Viewer": "Viewer",
    "VIEWER": "VIEWER",
    "Admin": "Admin",
    "ADMIN": "ADMIN",
    "ARCHIVED": "ARCHIVED",
    "ATTACHED NOTES": "ATTACHED NOTES",
    "DELETED": "DELETED",
    "PINNED": "PINNED",
    "OTHERS": "OTHERS",
    "PUBLIC NOTES": "PUBLIC NOTES",
    "FOLLOWINGS' NOTES": "FOLLOWINGS' NOTES",
    "SHARED WITH ME": "SHARED WITH ME",
    "BOOKMARKS": "BOOKMARKS",
    "MY TAGS": "MY TAGS",
    "general/enter-fullscreen-mode": "Enter fullscreen mode",
    "general/enter-presentation-mode": "Enter presentation mode",
    "general/math-preview": "Math Preview",
    "general/this-note-is-empty": "This note is empty",
    "general/this-notebook-is-empty": "This notebook is empty",
    "general/nothing-here": "Nothing here",
    "general/no-notes-found": "No more notes found",
    "general/no-more-notebooks-found": "No more notebooks found",
    "general/no-more-attachments-found": "No more attachments found",
    "general/no-notifications-found": "No notifications found",
    "general/clear-all": "Clear all",
    "general/Save": "Save",
    "general/Delete": "Delete",
    "general/Follow": "Follow",
    "general/Following": "Following",
    "general/Unfollow": "Unfollow",
    "general/my-notes": "My notes",
    "general/public-notes": "Public notes",
    "general/followings-notes": "Followings' notes",
    "general/shared-with-me": "Shared with me",
    "general/Bookmarks": "Bookmarks",
    "general/Archive": "Archive",
    "general/Trash": "Trash",
    "general/new-note": "New note",
    "general/new-attachment": "New attachment",
    "general/profile-updated": "Profile updated",
    "general/ID": "ID",
    "general/Audio": "Audio",
    "general/Video": "Video",
    "general/source-url": "Source URL",
    "general/sign-in": "Sign in",
    "general/sign-up": "Sign up",
    "general/Link": "Link",
    "general/Upload": "Upload",
    "general/Uploading": "Uploading",
    "general/clicks": "clicks",
    "general/Processing": "Processing...",
    "general/please-wait": "Please wait...",
    "general/please-sign-in-first": "Please sign in first",
    "general/Languages": "Languages",
    "general/track": "Track",
    "general/Open": "Open",
    "general/Download": "Download",
    "general/Configure": "Configure",
    "general/Update": "Update",
    "general/empty": "empty",
    "general/Notebooks": "Notebooks",
    "general/add-a-notebook": "Add a notebook",
    "general/add-a-note": "Add a note",
    "general/add-an-attachment": "Add an attachment",
    "general/configure-the-notebook": "Configure the notebook",
    "general/notebook-name": "Notebook name",
    "general/git-repository": "git repository",
    "general/optional": "optional",
    "general/url": "Url",
    "general/branch": "branch",
    "general/remember-username-and-password": "Remember credentials",
    "general/stored-locally": "stored locally",
    "general/cors-proxy": "CORS proxy",
    "general/why-cors-proxy": "Why do we need CORS proxy？",
    "general/today": "Today",
    "general/todo": "Todo",
    "general/wiki": "Wiki",
    "general/tagged": "Tagged",
    "general/untagged": "Untagged",
    "general/encrypt": "Encrypt",
    "general/encrypted": "Encrypted",
    "general/decrypt": "Decrypt",
    "general/conflicted": "Conflicted",
    "general/attachments": "Attachments",
    "general/Pin": "Pin",
    "general/Encryption": "Encryption",
    "general/Fullscreen": "Fullscreen",
    "general/change-file-path": "Change file path",
    "general/create-a-copy": "Create a copy",
    "general/restore-checkout": "Restore (git checkout)",
    "general/download-pull": "Download (git pull)",
    "general/upload-push": "Upload (git pull & git push)",
    "general/disable-the-encryption-on-this-note":
      "Disable the encryption on this note",
    "general/encrypt-this-note-with-password":
      "Encrypt this note with password",
    "general/disable-encryption": "Disable encryption",
    "general/decrypt-this-note": "Decrypt this note",
    "general/upload-the-profile": "Upload profile",
    "general/commit-message": "Commit message",
    "general/upload-notebook": "Upload the notebook",
    "general/Comments": "Comments",
    "general/Source": "Source",
    "general/Description": "Description",
    "general/Edit": "Edit",
    "general/Rename": "Rename",
    "general/rename-directory": "Rename directory",
    "general/delete-directory": "Delete directory",
    "general/rename-tag": "Rename tag",
    "general/delete-tag": "Delete tag",
    "general/notebook-updates-found": "Notebook updates found",
    "general/update-the-notebook": "Update the notebook",
    "general/check-notebook-updates-periodically":
      "Check notebook updates periodically",
    "general/minutes": "minute(s)",
    "general/hard-reset": "Hard reset",
    "general/Default": "Default",
    "general/Vim": "Vim",
    "general/Emacs": "Emacs",
    "general/Desc": "Desc",
    "general/Asc": "Asc",

    // Error
    "error/authentication-failed": "Authentication failed",
    "error/failed-to-upload-notebook": "Failed to upload notebook",
    "error/failed-to-download-notebook": "Failed to download notebook",
    "error/notebook-already-exists": "Notebook already exists",
    "error/invalid-git-url-prefix": "Invalid git URL prefix",
    "error/please-resolve-conflicts": "Please resolve conflicts first",
    "error/failed-to-disable-encryption": "Failed to disable encryption",
    "error/decryption-failed": "Decryption failed",
    "error/failed-to-change-file-path": "Failed to change file path",
    "error/failed-to-create-widget": "Failed to create widget",
    "error/failed-to-load-widget": "Failed to load widget",
    "error/failed-to-update-the-notebook": "Failed to update the notebook",

    // Success
    "success/notebook-uploaded": "Notebook uploaded",
    "success/notebook-downloaded": "Notebook downloaded",

    // Info
    "info/downloading-notebook": "Downloading notebook",

    // Note
    "note/unarchive-note": "Unarchive note",
    "note/archive-note": "Archive note",
    "note/delete-forever": "Delete forever",
    "note/delete-note": "Delete note",
    "note/restore-note": "Restore note",
    "note/report-note": "Report note",
    "note/open-in-crossnote-website": "Open in Crossnote website",

    // NoteTags
    "note-tags/send-suggestion-failure": "Failed to send suggestion",
    "note-tags/suggestion-sent": "Suggestion sent",
    "note-tags/suggest-a-tag-to-this-note": "Suggest a tag to this note",

    // UserTags
    "user-tags/follow-a-tag": "Follow a tag",

    // Notifications
    "notifications/refresh": "Refresh to see new notifications",
    "notifications/new-version-available":
      "A new version of Crossnote is available!",

    // Settings
    "settings/about-this-project": "About this project",
    "settings/issues-and-feature-requests":
      "Found issues or have feature requests?",
    "settings/uploading-cover-image": "Uploading cover image",
    "settings/upload-image-failure": "Failed to upload image",
    "settings/Cover": "Cover",
    "settings/enter-cover-image-url": "Enter cover image URL",
    "settings/upload-image": "Upload image",
    "settings/Avatar": "Avatar",
    "settings/enter-avatar-image-url": "Enter avatar image URL",
    "settings/Name": "Name",
    "settings/enter-name": "Enter your Name (this is not your username)",
    "settings/editor-cursor-color": "Editor cursor color",
    "settings/hello": "Hello, ",
    "settings/world": "world!",
    "settings/linked-with-github-account": "Linked with GitHub account",
    "settings/link-with-github-account": "Link with GitHub account",
    "settings/log-out": "Log out",
    "settings/author-name": "Author name",
    "settings/author-email": "Author email",
    "settings/theme": "Theme",
    "settings/created-cloud-widgets-count": "Created cloud widgets count",
    "settings/key-map": "Key Map",

    // Preview
    "preview/attach-a-note": "Attach a note",
    "preview/crossnote-untitled": "Crossnote - Untitled",
    "preview/edit-this-note": "Edit this note",

    // ProfileCard
    "profile-card/followings": "followings",
    "profile-card/followers": "followers",
    "profile-card/Followings": "Followings",
    "profile-card/Followers": "Followers",
    "profile-card/notes": "notes",
    "profile-card/follow-user-failure": "Failed to follow user",
    "profile-card/followed-user": "Followed user",
    "profile-card/unfollow-user-failure": "Failed to unfollow user",
    "profile-card/unfollowed-user": "Unfollowed user",

    // TagCard
    "tag-card/pin-to-my-notes-page": "Pin to my notes page",

    // Interaction panel
    "interaction-panel/show-attached-notes": "Show attached notes",
    "interaction-panel/add-comment": "Add comment",
    "interaction-panel/add-reaction": "Add reaction",

    // Editor
    "editor/loading-your-note": "Loading your note...",
    "editor/sync-failure": "Failed to sync... Please refresh your page",
    "editor/saving": "Saving...",
    "editor/save-failure": "Failed to save",
    "editor/saved": "Saved",
    "editor/update-note-failure": "Failed to update note",
    "editor/placeholder": "#  Hi 😀 Type '/' for commands",
    "editor/ln": "Ln",
    "editor/col": "Col",

    // * NoteControl
    "editor/note-control/allow-readers-to-suggest-note-tags":
      "Allow readers to suggest note tags",
    "editor/note-control/allow-readers-to-attach-notes-under-this-note":
      "Allow readers to attach notes under this note",
    "editor/note-control/inherit-parent-note-collaborators-list":
      "Inherit parent note collaborators list",
    "editor/note-control/note-visibility-hint":
      "All collaborators will be able to see this note",
    "editor/note-control/allow-readers-to-attach-notes-unchecked":
      "Applies to you and collaborators that can edit and admin",
    "editor/note-control/allow-readers-to-attach-notes-checked":
      "Applies to anyone that can view this note",
    "editor/note-control/enter-parent-note-id": "Enter parent note ID",
    "editor/note-control/attach-note-failure": "Failed to attach note",
    "editor/note-control/unattach-note-failure": "Failed to unattach note",
    "editor/collaborator-hint": " - note will be visible to them",
    "editor/shareable-link-hint":
      "people with the link can view/edit this note with no need of login",

    // * BackupsControl
    "editor/backups-control/create-backup": "Create backup",
    "editor/backups-control/delete-this-backup": "Delete this backup",
    "editor/backups-control/create-backup-failure": "Failed to create backup",
    "editor/backups-control/backup-created": "Backup created",
    "editor/backups-control/delete-backup-failure": "Failed to delete backup",
    "editor/backups-control/backup-deleted": "Backup deleted",
    "editor/backups-control/cloud-version": "Cloud version",
    "editor/backups-control/backup-name": "Backup name",

    // * CollaboratorasControl
    "editor/collaborators-control/set-collaborator-role-failure":
      "Failed to set collaborator role",
    "editor/collaborators-control/add-collaborator-failure":
      "Failed to add collaborator",
    "editor/collaborators-control/collaborator-removed": "Collaborator removed",
    "editor/collaborators-control/collaborator-added": "Collaborator added",
    "editor/collaborators-control/can-view": "Can view",
    "editor/collaborators-control/can-edit": "Can edit",
    "editor/collaborators-control/can-administrate": "Can administrate",

    // * EditorToolBar
    "editor/toolbar/insert-image": "Insert image",
    "editor/toolbar/upload-local-images": "Upload local images",
    "editor/toolbar/capture-webpage": "Capture the whole webpage",
    "editor/toolbar/insert-clock": "Insert clock",
    "editor/toolbar/insert-emoji": "Insert emoji",
    "editor/toolbar/insert-media": "Insert media",
    "editor/toolbar/insert-audio": "Insert Audio",
    "editor/toolbar/netease-music": "Netease Music",
    "editor/toolbar/insert-video": "Insert video",
    "editor/toolbar/insert-youtube": "Insert Youtube",
    "editor/toolbar/insert-bilibili": "Insert Bilibili",
    "editor/toolbar/insert-slide": "Insert slide",
    "editor/toolbar/insert-ocr": "Insert OCR",
    "editor/toolbar/insert-kanban": "Insert Kanban",
    "editor/toolbar/insert-abc-notation": "Insert ABC notation",
    "editor/toolbar/insert-header-1": "Insert header 1",
    "editor/toolbar/insert-header-2": "Insert header 2",
    "editor/toolbar/insert-header-3": "Insert header 3",
    "editor/toolbar/insert-header-4": "Insert header 4",
    "editor/toolbar/insert-header-5": "Insert header 5",
    "editor/toolbar/insert-header-6": "Insert header 6",
    "editor/toolbar/bold": "Bold",
    "editor/toolbar/italic": "Italic",
    "editor/toolbar/strikethrough": "Strikethrough",
    "editor/toolbar/insert-inline-code": "Insert inline code",
    "editor/toolbar/insert-blockquote": "Insert blockquote",
    "editor/toolbar/insert-unordered-list": "Insert unordered list",
    "editor/toolbar/insert-ordered-list": "Insert ordered list",
    "editor/toolbar/insert-link": "Insert link",
    "editor/toolbar/insert-table": "Insert table",
    "editor/toolbar/insert-comment": "Insert crossnote cloud comment widget",
    "editor/toolbar/insert-github-gist": "Insert GitHub Gist",

    // * NoteControl
    "editor/note-control/tag-added": "Tag added",
    "editor/note-control/tag-deleted": "Tag deleted",
    "editor/note-control/set-note-visibility-failure":
      "Failed to set note visibility",
    "editor/note-control/note-visibility-updated": "Note visibility updated",
    "editor/note-control/set-author-visibility-failure":
      "Failed to set author visibility",
    "editor/note-control/author-visibility-updated":
      "Author visibility updated",
    "editor/note-control/editor-mode": "Editor mode",
    "editor/note-control/source-code": "Source code",
    "editor/note-control/preview": "Preview",
    "editor/note-control/split-view": "Split view",
    "editor/note-control/pin-preview": "Pin preview on the side",
    "editor/note-control/display-modification-records":
      "Display modification records",
    "editor/note-control/note-visibility": "Note visibility",
    "editor/note-control/author-visibility": "Author visibility",
    "editor/note-control/shareable-link": "Shareable link",
    "editor/note-control/copy-to-clipboard": "Copy to clipboard",
    "editor/note-control/link-to-preview": "Link to preview",
    "editor/note-control/link-to-editor": "Link to editor",
    "editor/note-control/attach-to-note": "Attach to note",
    "editor/note-control/source-added": "URL added",
    "editor/note-control/source-deleted": "URL deleted",
    "editor/note-control/invalid-note-source": "Invalid URL",
    "editor/note-control/add-note-source": "Add related URLs",
    "editor/note-control/note-source-hint":
      "Notes on the same URL will be grouped together",
    "editor/note-control/enter-note-source": "Enter URL",

    // AvatarPanel
    "avatar-panel/this-note-is-private": "This note is private",
    "avatar-panel/this-note-is-public": "This note is visible to public",
    "avatar-panel/this-note-is-friends-only":
      "This note is only visible to friends",
    "avatar-panel/you-are-anonymous": "You are anonymous",

    // FileExporter
    "file-exporter/name": "File exporter",
    "file-exporter/orientation": "Orientation",
    "file-exporter/portrait": "portrait",
    "file-exporter/landscape": "landscape",
    "file-exporter/paper-size": "Paper size",
    "file-exporter/unit": "Unit",
    "file-exporter/margin-top": "Margin top",
    "file-exporter/margin-bottom": "Margin bottom",
    "file-exporter/margin-left": "Margin left",
    "file-exporter/margin-right": "Margin right",

    // Utils
    "utils/uploading-image": "Uploading image...",
    "utils/upload-image-failure": "Failed to upload image",

    // Notification
    // * CommentPostingNotification
    "notification/replies-to-you-in": "Replies to you in",
    "notification/'s-note": "'s note ",
    // * NoteReactionNotification
    "notification/added": "Added",
    "notification/to-your-note": "to your note",
    "notification/add-you-as": "Added you as",
    "notification/of-note": "of note",
    // * NoteTagSuggestion
    "notification/add-tag-failure": "Failed to add tag",
    "notification/suggested-to-add-tag": "Suggested to add tag",
    // * UserFollowingNotification
    "notification/started-following-you": "Started following you",
    // * BookmarkNotification
    "notification/bookmarked-your-note": "Bookmarked your note",
    "notification/view-more-notifications": "View more notifications",

    // Widgets
    "widget/autoplay": "autoplay",
    "widget/controls": "controls",
    "widget/loop": "loop",
    "widget/muted": "muted",
    "widget/creating-widget": "Creating widget",
    "widget/loading-widget": "Loading widget",
    "widget/crossnote.image/thanks_sm_ms":
      "Thanks sm.ms for offering free image hosting service.",
    "widget/crossnote.audio/audio_element_fail":
      "Your browser does not support the audio element.",
    "widget/crossnote.audio/source-url-placeholder":
      "Enter audio source URL here, then press 'Enter' to insert.",
    "widget/crossnote.video/video_element_fail":
      "Your browser does not support the video element",
    "widget/crossnote.bilibili/error_message":
      "Error: Only supported https://www.bilibili.com/video/av79126732 like URL",
    "widget/crossnote.youtube/error_message":
      "Error: Only supported https://www.youtube.com/watch?v=MmB9b5njVbA like URL",
    "widget/crossnote.auth/welcome": "Welcome to Crossnote",
    "widget/crossnote.auth/doesnt-have-account":
      "Doesn't have an account? Let's create one 😉!",
    "widget/crossnote.auth/forgot_password": "Forgot your password 😣?",
    "widget/crossnote.auth/failed_to_send_code":
      "Failed to send verification code",
    "widget/crossnote.auth/verification_code_sent":
      "Verification code has been sent to ",
    "widget/crossnote.auth/failed_to_reset_password":
      "Failed to reset password",
    "widget/crossnote.auth/password_reset": "Your password has been reset",
    "widget/crossnote.auth/password-mismatch": "Passwords mismatch",
    "widget/crossnote.auth/hello": "Hello, ",
    "widget/crossnote.auth/enter-the-verification-code":
      "Enter the verification code",
    "widget/crossnote.auth/get-code": "Get code",
    "widget/crossnote.auth/sign-in-with-github-account":
      "Sign in with GitHub account",
    "widget/crossnote.auth/already-have-an-account": "Already have an account?",
    "widget/crossnote.auth/reset-password": "Reset password",
    "widget/crossnote.auth/Or": "Or",
    "widget/crossnote.bilibili/Bilibili": "Bilibili",
    "widget/crossnote.bilibili/bilibili-video-url": "Bilibili video URL",
    "widget/crossnote.bilibili/url-placeholder":
      "Enter the Bilibili video URL here, then press 'Enter' to insert.",
    "widget/crossnote.image/image-helper": "Image helper",
    "widget/crossnote.image/image-url-placeholder":
      "Enter image URL here, then press 'Enter' to insert.",
    "widget/crossnote.image/click-here-to-browse-image-file":
      "Click here to browse image file",
    "widget/crossnote.neteasemusic/song-id-placeholder":
      "Enter Netease Music song number ID.",
    "widget/crossnote.video/video-url-placeholder":
      "Enter video source URL here, then press 'Enter' to insert.",
    "widget/crossnote.video/poster-url": "Poster URL (optional)",
    "widget/crossnote.video/poster-url-placeholder": "Enter poster URL here.",
    "widget/crossnote.youtube/youtube-video-url": "Youtube video URL",
    "widget/crossnote.youtube/youtube-video-url-placeholder":
      "Enter the Youtube video URL here, then press 'Enter' to insert.",
    "widget/crossnote.ocr/ocr": "OCR - Optical character recognition",
    "widget/crossnote.ocr/local-image": "Local image",
    "widget/crossnote.ocr/recognize-text-in-languages":
      "Recognize text in languages",
    "widget/crossnote.ocr/start-ocr": "Start OCR",
    "widget/crossnote.ocr/extra-settings": "Extra settings",
    "widget/crossnote.ocr/grayscale": "Grayscale",
    "widget/crossnote.kanban/add-column": "Add new column",
    "widget/crossnote.github_gist/title": "Embed a GitHub Gist",
    "widget/crossnote/github_gist/enter-github-gist-url":
      "Enter GitHub Gist URL",

    // Tesseract
    "tesseract/loading tesseract core": "loading tesseract core",
    "tesseract/initializing tesseract": "initializing tesseract",
    "tesseract/initialized tesseract": "initialized tesseract",
    "tesseract/loading language traineddata": "loading language traineddata",
    "tesseract/loaded language traineddata": "loaded language traineddata",
    "tesseract/initializing api": "initializing api",
    "tesseract/initialized api": "initialized api",
    "tesseract/recognizing text": "recognizing text",

    // Comment widget
    "widget/crossnote.comment/reply-to-this-user": "Reply to this user",
    "widget/crossnote.comment/add-reaction-to-this-comment":
      "Add reaction to this comment",
    "widget/crossnote.comment/edit-this-message": "Edit this comment",
    "widget/crossnote.comment/modified-comment": "modified comment",
    "widget/crossnote.comment/post-comment-failure": "Failed to post comment",
    "widget/crossnote.comment/unsubscribe-info":
      "Unsubscribe from the comments",
    "widget/crossnote.comment/subscribe-info": "Subscribe to the comments",
    "widget/crossnote.comment/view-more-comments": "View more comments",

    // Dialogs
    "delete-note-dialog/title": "Are you sure to delete this note?",
    "delete-note-dialog/subtitle": "You can't undo this action.",
    "delete-directory-dialog/title": "Are you sure to delete this directory?",
    "delete-directory-dialog/subtitle":
      "All the child directories and notes will also be deleted. You can't undo this action.",
    "delete-tag-dialog/title": "Are you sure to delete this tag?",
    "delete-tag-dialog/subtitle":
      "All the child tags will also be deleted. You can't undo this action.",
    "add-notebook-dialog/disclaimer":
      "Notebook data will only be stored locally in browser for offline uses. We won't upload any notebook data to our server.",
    "edit-image-dialog/title": "Edit the image",
    "edit-image-dialog/image-url": "image URL",
    "edit-image-dialog/image-title": "image title",
    "edit-image-dialog/image-alt-text": "image alt text",
    "language-selector-dialog/subtitle": "Please choose the preferred language",

    // react-ios-pwa-prompt
    "react-ios-pwa-prompt/copy-title": "Add to Home Screen",
    "react-ios-pwa-prompt/copy-body":
      "This website has app functionality. Add it to your home screen to use it in fullscreen and while offline.",
    "react-ios-pwa-prompt/copy-share-button-label":
      "1) Press the 'Share' button",
    "react-ios-pwa-prompt/copy-add-home-button-label":
      "2) Press 'Add to Home Screen'",
      
    // git
    "git/status/ignored": "ignored",
    "git/status/unmodified": "unmodified",
    "git/status/*modified": "*modified",
    "git/status/*deleted": "*deleted",
    "git/status/*added": "*added",
    "git/status/absent": "absent",
    "git/status/modified": "modified",
    "git/status/deleted": "deleted",
    "git/status/added": "added",
    "git/status/*unmodified": "*unmodified",
    "git/status/*absent": "*absent",
    "git/status/*undeleted": "*undeleted",
    "git/status/*undeletemodified": "*undeletemodified",
    "git/status/": "",
  },
};
